import React, { useState } from "react";
import { getAllClassNames } from "helpers";
import strings from "assets/strings";
import styles from "./CustomSortDropdown.module.scss";
// import { ArrowDownBlue } from "assets/icons";
// import Button from "components/buttons/button/Button";
import {
  useSortBy,
} from "react-instantsearch";
import { FilterButton } from "components/buttons/filterButton/FilterButton";

type IDropdownProps = {
  items: any[];
  title?: string;
  multiSelect?: boolean;
  slectedValue?: string;
  defaultValue?: number;
  onSortChange?: (sortBy: string) => void; // Add this new prop

}

export const CustomSortDropdown = ({
  items,
  title,
  multiSelect,
  slectedValue,
  defaultValue,
  onSortChange,
  ...props
  
}: IDropdownProps) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const { options, currentRefinement = options[0].value, refine } = useSortBy({ items });

  const handleSelectedOption = (value: string): void => {
    refine(value);
    if (onSortChange) {
      onSortChange(value); // Call the parent's setter
    }
    setShowDropdown(false);
  };

  return (
    <div className={styles.container} {...props}>
        <FilterButton className={styles.button} onClick={() => setShowDropdown(prev => !prev)} text={strings.globalStrings.sortBy} iconName="ArrowDownBlue"/>
      {showDropdown && (
        <div className={styles.dropdown}>
         
          {options.map((item) => (
            <li
              key={item.value}
              onClick={() => {handleSelectedOption(item.value)}}
              className={getAllClassNames([
                "ais-RefinementList-item",
                currentRefinement == item.value && styles.itemSelected,
              ])}
            >
                <span className={styles.label}>
                  {item.label}
                </span>
            </li>
          ))}
        </div>
      )}
    </div>
  );
};
